import { createIcon } from '@chakra-ui/react';

export const UnLockIcon = createIcon({
  displayName: 'UnLockIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_3433_85685)">
          <path
            d="M13.3337 5.33355H11.3337V4.14022C11.3337 2.40022 10.0603 0.846882 8.32699 0.680215C6.34033 0.493548 4.66699 2.05355 4.66699 4.00022H6.00033C6.00033 3.24688 6.40033 2.50688 7.09366 2.20022C8.56699 1.54022 10.0003 2.60022 10.0003 4.00022V5.33355H2.66699V14.6669H13.3337V5.33355ZM12.0003 13.3335H4.00033V6.66688H12.0003V13.3335ZM8.00033 11.3335C8.73366 11.3335 9.33366 10.7335 9.33366 10.0002C9.33366 9.26688 8.73366 8.66688 8.00033 8.66688C7.26699 8.66688 6.66699 9.26688 6.66699 10.0002C6.66699 10.7335 7.26699 11.3335 8.00033 11.3335Z"
            fill="#6E6789"
          />
        </g>
        <defs>
          <clipPath id="clip0_3433_85685">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
